import React from 'react';
import { sortBy, isUndefined } from 'lodash';
import SkillIcon from './SkillIcon';
import './skillIconList.scss';

const SkillIconList = ({ skills, showScheduleIconsOnly, maxDisplay }) => {
  if (!skills || skills.length === 0) return null;
  showScheduleIconsOnly = isUndefined(showScheduleIconsOnly) ? false : showScheduleIconsOnly;
  skills = sortBy(skills, 'order');
  skills = skills.filter(Boolean); // remove all undefined or nulls
  if (showScheduleIconsOnly) {
    skills = skills.filter(skill => skill.show_icon_in_schedule != false);
  } // remove if showScheduleIconsOnly false

  const displaySkills = maxDisplay ? skills.slice(0, maxDisplay) : skills;

  return (
    <div className="skill-icon-list">
      {displaySkills.map((skill, index) => (
        <SkillIcon key={skill.id} skill={skill} className={index == skills.length - 1 ? '' : 'me-1'} />
      ))}
    </div>
  );
};

export default SkillIconList;
